export const parseEnvBoolean = (value?: string): boolean => {
  if (!value) return false;

  return value.toString().toLowerCase() === 'true';
};
